import { NestedLink } from "@fanduel/og-fe-library";

export function getSiteNavItems(
  navLinks: (NestedLink | null | undefined)[]
): { name: string; url: string }[] {
  return (navLinks || [])
    .filter(
      (link): link is NestedLink =>
        !!link && typeof link.text === "string" && typeof link.url === "string"
    )
    .flatMap((link) => [
      { name: link.text, url: link.url },
      ...(Array.isArray(link.children) ? getSiteNavItems(link.children) : []),
    ]);
}
